module.exports = __webpack_public_path__ + "media/images/emblems/Ruedtligen-Alchenflueh-coat_of_arms-dc51f10dfa1a4ca376673b7280c33a5b.svg";